import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AntdLayoutState  = {
    siderCollapsed: boolean;
    selectedMenuItemKeys: string[];
    openKeys: string[];
    needWideningForWorkInstructions: boolean;
};

const initialState: AntdLayoutState = {
    siderCollapsed: false,
    selectedMenuItemKeys: [],
    openKeys: [],
    needWideningForWorkInstructions: false
};

export const antdLayoutInfoSlice = createSlice({
    name: 'antdLayoutInfo',
    initialState,
    reducers: {
        toggleSiderCollapse: (state) => {
            state.siderCollapsed = !state.siderCollapsed;
        },
        setSelectedMenuItemKeys: (state, action: PayloadAction<string[]>) => {
            state.selectedMenuItemKeys = action.payload;
        },
        setOpenKeys: (state, action: PayloadAction<string[]>) => {
            state.openKeys = action.payload;
        },
        setNeedWideningForWorkInstructions: (state, action: PayloadAction<boolean>) => {
            state.needWideningForWorkInstructions = action.payload;
        }
    }
});

export const {
    toggleSiderCollapse,
    setSelectedMenuItemKeys,
    setOpenKeys,
    setNeedWideningForWorkInstructions
} = antdLayoutInfoSlice.actions;